"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureComponent = void 0;
const react_1 = require("react");
const React = require("react");
require("./signature-pad.less");
class SignatureComponent extends react_1.Component {
    constructor() {
        super(...arguments);
        this.drawing = false;
        this.preventDefault = (e) => {
            e.preventDefault();
        };
        this.resize = () => {
            if (this.ctx) {
                this.ctx.canvas.width = window.innerWidth - 120;
            }
        };
        this.getImage = () => {
            if (this.canvas) {
                return this.canvas.toDataURL();
            }
            return null;
        };
        this.setInitialPosition = (pos) => {
            if (pos) {
                this.ctx && this.ctx.moveTo(pos.x, pos.y);
            }
        };
        this.setLineProps = () => {
            const context = this.canvas && this.canvas.getContext("2d");
            if (context) {
                context.lineWidth = 2;
                context.lineJoin = context.lineCap = "round";
                context.shadowBlur = 2;
                context.shadowColor = "rgba(0, 0, 0, .5)";
            }
        };
        this.handleTouchDown = (event) => {
            // Prevent page scrolling when drawing
            event.preventDefault();
            event.stopPropagation();
            this.drawing = true;
            const pos = this.getTouchPos(event);
            this.setLineProps();
            this.setInitialPosition(pos);
        };
        this.handleTouchMove = (event) => {
            if (this.drawing) {
                const pos = this.getTouchPos(event);
                this.handleDraw(pos);
            }
        };
        this.handleTouchUp = (event) => {
            if (!this.canvas)
                return;
            this.drawing = false;
            this.props.onChange && this.props.onChange(this.canvas.toDataURL());
        };
        this.getTouchPos = (event) => {
            if (!this.canvas)
                return null;
            const rect = this.canvas.getBoundingClientRect();
            return {
                x: event.touches[0].clientX - rect.left,
                y: event.touches[0].clientY - rect.top
            };
        };
        this.handleMouseDown = (event) => {
            this.drawing = true;
            const pos = this.getMousePos(event);
            this.setLineProps();
            this.setInitialPosition(pos);
        };
        this.getMousePos = (event) => {
            if (!this.canvas)
                return null;
            const rect = this.canvas && this.canvas.getBoundingClientRect();
            return {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top
            };
        };
        this.handleMouseMove = (event) => {
            if (this.drawing) {
                const pos = this.getMousePos(event);
                this.handleDraw(pos);
            }
        };
        this.handleMouseUp = (event) => {
            if (!this.canvas)
                return;
            this.drawing = false;
            this.props.onChange && this.props.onChange(this.canvas.toDataURL());
        };
        this.handleClear = (event) => {
            if (this.canvas) {
                this.ctx &&
                    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                // Reset canvas data
                this.canvas.width = this.canvas.width;
                this.props.onReset(this.canvas.toDataURL());
            }
        };
        this.handleDraw = (pos) => {
            if (pos) {
                this.ctx && this.ctx.lineTo(pos.x, pos.y);
                this.ctx && this.ctx.stroke();
            }
        };
        this.handleLeave = () => {
            this.drawing = false;
        };
    }
    get ctx() {
        return this.canvas && this.canvas.getContext("2d");
    }
    componentDidMount() {
        window.addEventListener("resize", this.resize);
        /**
         * Looks like this is foxed in a later version of TS
         * https://github.com/Microsoft/TypeScript/issues/9548
         */
        window.addEventListener("touchmove", this.preventDefault, {
            passive: false
        });
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("touchmove", this.preventDefault);
    }
    render() {
        const { className = "", height = 330, width = "" } = this.props;
        return (React.createElement("div", { className: "signature-pad-wrapper", style: { width, height } },
            React.createElement("div", { className: "clear-btn", onClick: this.handleClear }, "reset"),
            React.createElement("div", { className: "baseline" }),
            React.createElement("canvas", { className: `signature-pad ${className}`, ref: ref => (this.canvas = ref), width: width, height: height, onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp, onMouseLeave: this.handleLeave, onTouchStart: this.handleTouchDown, onTouchMove: this.handleTouchMove, onTouchEnd: this.handleTouchUp })));
    }
}
exports.SignatureComponent = SignatureComponent;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/signature-pad/signature-pad.tsx
// module id = 2961
// module chunks = 0 1